<p>{{props?.label + (props?.required ? ' *' : ' ')}}</p>

<form [formGroup]="checkboxFormList">
    <div class="form-check" *ngFor="let option of props?.options">
        <input class="form-check-input" type="checkbox"
            [formControlName]="option.fieldName" [value]="option.value">
        <label class="form-check-label" for="flexCheckChecked">
            {{option.label}}
        </label>
    </div>
</form>

<br>